import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/wechat/officialAccount/basicSettings',
    name: 'wechatOfficialAccountBasicSettings',
    component: () => import('@/views/apply/wechat/officialAccount/basicSettings.vue'),
    meta: {
      title: i18n.t('router.wechat.official_account_settings'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/officialAccount/templateMessage',
    name: 'wechatMiniprogramTemplateMessage',
    component: () => import('@/views/apply/wechat/officialAccount/templateMessage.vue'),
    meta: {
      title: i18n.t('router.wechat.template_message'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/officialAccount/customizeMenu',
    name: 'wechatOfficialAccountCustomizeMenu',
    component: () => import('@/views/apply/wechat/officialAccount/customizeMenu'),
    meta: {
      title: i18n.t('router.wechat.custom_menu'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/officialAccount/automaticReply',
    name: 'wechatOfficialAccountAutomaticReply',
    component: () => import('@/views/apply/wechat/officialAccount/autoReply/index'),
    meta: {
      title: i18n.t('router.wechat.auto_reply'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/miniprogram/basicSettings',
    name: 'wechatMiniprogramBasicSettings',
    component: () => import('@/views/apply/wechat/miniprogram/basicSettings.vue'),
    meta: {
      title: i18n.t('router.wechat.mini_program_settings'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/miniprogram/publishMiniProgram',
    name: 'wechatMiniprogramPublishMiniProgram',
    component: () => import('@/views/apply/wechat/miniprogram/publishMiniProgram.vue'),
    meta: {
      title: i18n.t('router.wechat.mini_program_publish'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/miniprogram/orderList',
    name: 'wechatMiniprogramOrderList',
    component: () => import('@/views/apply/wechat/miniprogram/orderList.vue'),
    meta: {
      title: i18n.t('router.wechat.delivery_info_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/wechat/miniprogram/forwardingSettings',
    name: 'wechatMiniprogramForwardingSettings',
    component: () => import('@/views/apply/wechat/miniprogram/forwardingSettings.vue'),
    meta: {
      title: i18n.t('router.wechat.forward_settings'),
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/wechat.js